export function pushToFrame(output: number[], landmarks: any[] | null, expectedCount: number): void {
    if (landmarks && Array.isArray(landmarks)) {
        for (let i = 0; i < landmarks.length; i++) {
            const lm = landmarks[i];
            output.push(lm?.x);
            output.push(lm?.y);
            output.push(lm?.z);
        }
    } else {
        for (let i = 0; i < expectedCount; i++) {
            output.push(NaN);
            output.push(NaN);
            output.push(NaN);
        }
    }
}

export function frameToResults(flatInput: number[]): {
    poseLandmarks: any[] | null,
    leftHandLandmarks: any[] | null,
    rightHandLandmarks: any[] | null,
    faceLandmarks: any[] | null,
} {
    // Do not mutate caller array
    const flat = flatInput.slice();
    let idx = 0;

    const take = (count: number) => {
        const out: any[] = [];
        for (let i = 0; i < count; i++) {
            const x = flat[idx++];
            const y = flat[idx++];
            const z = flat[idx++];
            if (Number.isNaN(x) || Number.isNaN(y) || Number.isNaN(z)) {
                out.push(null);
            } else {
                out.push({ x, y, z, visibility: 1 });
            }
        }
        return out.some(p => p) ? out : null;
    };

    const poseLandmarks = take(33);
    const leftHandLandmarks = take(21);
    const rightHandLandmarks = take(21);
    const faceLandmarks = take(468);

    return { poseLandmarks, leftHandLandmarks, rightHandLandmarks, faceLandmarks };
}


